export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/daniel-olahh-facbbdb787d77f975904ba9fa99b15c6.jpg";